import { AddonAction } from 'models/AddonAction';
import { ReadonlyValueDefinition } from 'models/metadata/readonlyValue.definition';
import { TradeWay } from 'models/TradeWay';
import type { Collection } from 'state/utils/types';

export type SidePanelTabId =
  | 'quotation'
  | 'greeksFeesMetrics'
  | 'regulatory'
  | 'advisory'
  | 'missedDealFeedback'
  | 'backTest';

export interface SidePanelUiState {
  activeTab: SidePanelTabId;
  metadata?: SidePanelUiMetadata;

  fieldsMetadata: Readonly<Record<string, ReadonlyValueDefinition>>;
}

export interface SidePanelUiMetadata {
  tradeWay?: TradeWay;
  addonAction?: AddonAction;
}

export const initialSidePanelUiState: SidePanelUiState = {
  activeTab: 'quotation',
  metadata: {
    tradeWay: 'Sell',
    addonAction: 'Increase',
  },
  fieldsMetadata: {},
};

export type SidePanelUiStateMap = Collection<SidePanelUiState>;
